/**
 * Created by Allan on 2026/01/12.
 * Contact 84880528@qq.com.
 * 智利/ValorPec移动H5项目
 */
import Vue from 'vue'
import App from './App'
import router from '@/valorpecapp/router/'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/valorpecapp/filters/'
import Http from '@/config/Http'
import getQueryString from "@/config/getQueryString";

Vue.use(Vant);
Vue.prototype.$http = Http;
Vue.prototype.$token = getQueryString(location.hash, "token") || '';
Vue.prototype.$appid = getQueryString(location.hash, "appId") || '';
Vue.config.productionTip = false

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/valorpecapp/main.js